import { useMemo } from 'react'
import moment from 'moment'

import { FormFiltersType } from '@pages/BarChartPage/BarChartPage'

export const useDefaultValues = (): FormFiltersType => {
  return useMemo(
    () => ({
      planDay: moment().startOf('day').add(1, 'day').toISOString(),
      department: { id: 'СПО_Агент', label: 'СПО_Агент' },
      qual: { id: 'ALL', label: 'ALL' },
      // planQual: { id: 'ALL', label: 'ALL' },
      // staffQual: [],
    }),
    []
  )
}
